import { stringifyQs } from "@dashboard/utils/urls";

import { type Pagination, type Sort } from "../types";

export const abandonedCartListPath = "/abandoned-carts/";

export enum AbandonedCartListUrlSortField {
  created = "created",
  customer = "customer",
}

type AbandonedCartListUrlSort = Sort<AbandonedCartListUrlSortField>;

export type AbandonedCartListUrlQueryParams = AbandonedCartListUrlSort & Pagination;

export const abandonedCartListUrl = (params?: AbandonedCartListUrlQueryParams) =>
  abandonedCartListPath + "?" + stringifyQs(params);
